import { useMutation } from '@tanstack/react-query';
import { ApiClient, apiPaths, useApiErrorStoreActions } from '@repo/api/client';
import { agreementEditSuccessResponseBodySchema } from './agreement-edit.schema';
var apiEndpoint = apiPaths.agreement.edit;
function postAgreementEdit(payload) {
    return ApiClient.fetch(apiEndpoint.path, {
        options: { method: 'PATCH', body: JSON.stringify(payload) },
        successSchema: agreementEditSuccessResponseBodySchema,
    });
}
export function usePatchAgreementEdit() {
    var setApiError = useApiErrorStoreActions().setApiError;
    return useMutation({
        retry: false,
        mutationFn: postAgreementEdit,
        onError: function (error) {
            setApiError({
                apiPathId: apiEndpoint.id,
                error: error,
            });
        },
    });
}
